import { render } from "./identityPop.vue?vue&type=template&id=0e09cfec&scoped=true&ts=true"
import script from "./identityPop.vue?vue&type=script&lang=ts"
export * from "./identityPop.vue?vue&type=script&lang=ts"

import "./identityPop.vue?vue&type=style&index=0&id=0e09cfec&lang=scss"
import "./identityPop.vue?vue&type=style&index=1&id=0e09cfec&lang=scss&scoped=true"

import exportComponent from "E:\\bjft\\bjft-merchant-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e09cfec"]])

export default __exports__